import amapi from 'Api/amapi'
import { SOFTPROTO_OPTIONS, SOFTPROTO_VALUES } from '@/consts/domains'

// API docs: https://www.softaculous.com/docs/api/api/

const initialState = () => ({
  step: 1,
  softId: '26',
  plugins: ['litespeed-cache'], // plugins to install. litespeed-cache as default
  theme: 'twentytwentyfour',
  softdomain: '',
  softproto: SOFTPROTO_VALUES.https.value,
  softprotoValues: SOFTPROTO_OPTIONS.slice(),
  softdirectory: '',
  language: 'en',
  softdb: '',
  dbusername: '',
  dbuserpass: '',
  admin_username: '',
  admin_pass: '',
  admin_email: '',
  site_name: 'My WordPress',
  site_desc: 'Blank',
  languages: [
    { value: 'en', label: 'English' },
    { value: 'ar', label: 'Arabic' },
    { value: 'sq', label: 'Albanian' },
    { value: 'bg_BG', label: 'Bulgarian' },
    { value: 'ca', label: 'Catalan' },
    { value: 'zh_CN', label: 'Chinese (Simplified)' },
    { value: 'zh_TW', label: 'Chinese (Traditional)' },
    { value: 'hr', label: 'Croatian' },
    { value: 'cs_CZ', label: 'Czech' },
    { value: 'da_DK', label: 'Danish' },
    { value: 'nl_NL', label: 'Dutch' },
    { value: 'fi', label: 'Finnish' },
    { value: 'fr_FR', label: 'French' },
    { value: 'de_DE', label: 'German' },
    { value: 'el', label: 'Greek' },
    { value: 'he_IL', label: 'Hebrew' },
    { value: 'hu_HU', label: 'Hungarian' },
    { value: 'id_ID', label: 'Indonesian' },
    { value: 'it_IT', label: 'Italian' },
    { value: 'ja', label: 'Japanese' },
    { value: 'ko_KR', label: 'Korean' },
    { value: 'nb_NO', label: 'Norwegian Bokmål' },
    { value: 'fa_IR', label: 'Persian' },
    { value: 'pl_PL', label: 'Polish' },
    { value: 'pt_PT', label: 'Portuguese (Portugal)' },
    { value: 'pt_BR', label: 'Portuguese (Brazil)' },
    { value: 'ro_RO', label: 'Romanian' },
    { value: 'ru_RU', label: 'Russian' },
    { value: 'sl_SI', label: 'Slovenian' },
    { value: 'sk_SK', label: 'Slovak' },
    { value: 'es_ES', label: 'Spanish' },
    { value: 'sv_SE', label: 'Swedish' },
    { value: 'th', label: 'Thai' },
    { value: 'tr_TR', label: 'Turkish' },
    { value: 'uk', label: 'Ukrainian' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'zh_HK', label: 'Chinese (Hong Kong)' },
  ],
  languagesTranslated: [
    { value: 'en', label: 'English' },
    { value: 'ar', label: 'العربية' },
    { value: 'sq', label: 'Shqip' },
    { value: 'bg_BG', label: 'Български' },
    { value: 'ca', label: 'Català' },
    { value: 'zh_CN', label: '简体中文' },
    { value: 'zh_TW', label: '繁體中文' },
    { value: 'hr', label: 'Hrvatski' },
    { value: 'cs_CZ', label: 'Čeština' },
    { value: 'da_DK', label: 'Dansk' },
    { value: 'nl_NL', label: 'Nederlands' },
    { value: 'fi', label: 'Suomi' },
    { value: 'fr_FR', label: 'Français' },
    { value: 'de_DE', label: 'Deutsch' },
    { value: 'el', label: 'Ελληνικά' },
    { value: 'he_IL', label: 'עברית' },
    { value: 'hu_HU', label: 'Magyar' },
    { value: 'id_ID', label: 'Bahasa Indonesia' },
    { value: 'it_IT', label: 'Italiano' },
    { value: 'ja', label: '日本語' },
    { value: 'ko_KR', label: '한국어' },
    { value: 'nb_NO', label: 'Norsk Bokmål' },
    { value: 'fa_IR', label: 'فارسی' },
    { value: 'pl_PL', label: 'Polski' },
    { value: 'pt_PT', label: 'Português (Portugal)' },
    { value: 'pt_BR', label: 'Português (Brasil)' },
    { value: 'ro_RO', label: 'Română' },
    { value: 'ru_RU', label: 'Русский' },
    { value: 'sl_SI', label: 'Slovenščina' },
    { value: 'sk_SK', label: 'Slovenčina' },
    { value: 'es_ES', label: 'Español' },
    { value: 'sv_SE', label: 'Svenska' },
    { value: 'th', label: 'ไทย' },
    { value: 'tr_TR', label: 'Türkçe' },
    { value: 'uk', label: 'Українська' },
    { value: 'vi', label: 'Tiếng Việt' },
    { value: 'zh_HK', label: '中文 (香港)' },
  ],
  availablePlugins: [],
  availableThemes: [],
  wizardApp: '', // for wizard_step2 endpoint
  insid: '',
  domainsInstallationRecentlyFailed: []
})
// woocommerce, litespeed-cache
// https://www.softaculous.com/docs/api/api/#install-a-script

const state = initialState

const getters = {
  step: state => state.step,
  softId: state => state.softId,
  languages: state => state.languages,
  softdomain: state => state.softdomain,
  softproto: state => state.softproto,
  softprotoValues: state => state.softprotoValues,
  softdirectory: state => state.softdirectory,
  language: state => state.language,
  softdb: state => state.softdb,
  dbusername: state => state.dbusername,
  dbuserpass: state => state.dbuserpass,
  admin_username: state => state.admin_username,
  admin_pass: state => state.admin_pass,
  admin_email: state => state.admin_email,
  site_name: state => state.site_name,
  site_desc: state => state.site_desc,
  plugins: state => state.plugins,
  availablePlugins: state => state.availablePlugins,
  availableThemes: state => state.availableThemes,
  wizardApp: state => state.wizardApp,
  theme: state => state.theme,
  insid: state => state.insid,
  domainsInstallationRecentlyFailed: state => state.domainsInstallationRecentlyFailed
}

const mutations = {
  SET_STEP (state, step) {
    state.step = step
  },
  SET_SOFT_ID (state, softId) {
    state.softId = softId
  },
  SET_SOFT_DOMAIN (state, softdomain) {
    state.softdomain = softdomain
  },
  SET_SOFTPROTO (state, softproto) {
    state.softproto = softproto
  },
  SET_SOFT_DIR (state, dir) {
    state.softdirectory = dir
  },
  SET_SOFT_DB (state, db) {
    state.softdb = db
  },
  SET_SOFT_DB_USER (state, user) {
    state.dbusername = user
  },
  SET_SOFT_ADMIN (state, login) {
    state.admin_username = login
  },
  SET_SOFT_ADMIN_PWD (state, pwd) {
    state.admin_pass = pwd
  },
  SET_SOFT_ADMIN_EMAIL (state, email) {
    state.admin_email = email
  },
  SET_SOFT_DB_PWD (state, pwd) {
    state.dbuserpass = pwd
  },
  SET_LANGUAGE (state, language) {
    state.language = language
  },
  SET_SOFT_NAME (state, name) {
    state.site_name = name
  },
  SET_SOFT_DESC (state, desc) {
    state.site_desc = desc
  },
  SET_INST_ID (state, insid) {
    state.insid = insid
  },
  SET_PLUGINS (state, plugins) {
    state.plugins = plugins
  },
  SET_THEME (state, theme) {
    state.theme = theme
  },
  SET_LANGUAGES (state, languages) {
    const existedLanguages = []
    state.languages.forEach((language) => {
      if (languages.includes(language.value)) {
        existedLanguages.push(language.value)
      }
    })
    const difference = languages.filter((language) => !existedLanguages.includes(language))
    difference.forEach((language) => {
      state.languages.push({ value: language, label: language })
    })
  },
  SET_AVAILABLE_PLUGINS (state, val) {
    state.availablePlugins = val
  },
  SET_AVAILABLE_THEMES (state, val) {
    state.availableThemes = val
  },
  SET_WIZARD_APP (state, wizardApp) {
    state.wizardApp = wizardApp
  },
  RESET_STATE (state) {
    state.step = 1
    state.softId = '26'
    state.plugins = ['litespeed-cache']
    state.theme = 'twentytwentyfour'
    state.softdomain = ''
    state.softdirectory = ''
    state.language = 'en'
    state.softdb = ''
    state.dbusername = ''
    state.dbuserpass = ''
    state.admin_username = ''
    state.admin_pass = ''
    state.admin_email = ''
    state.site_name = 'WordPress'
    state.site_desc = 'My new WordPress website'
  },
  ADD_DOMAINS_INSTALLATION_RECENTLY_FAILED (state, domain) {
    if (state.domainsInstallationRecentlyFailed.includes(domain)) {
      return
    }
    state.domainsInstallationRecentlyFailed = [domain, ...state.domainsInstallationRecentlyFailed]
  },
  REMOVE_DOMAINS_INSTALLATION_RECENTLY_FAILED (state, domain) {
    if (!state.domainsInstallationRecentlyFailed.includes(domain)) {
      return
    }
    state.domainsInstallationRecentlyFailed =
      state.domainsInstallationRecentlyFailed.toSpliced(state.domainsInstallationRecentlyFailed.indexOf(domain), 1)
  },
}

const actions = {
  async getWpSoftId ({ commit, dispatch }, _username) {
    const data = {
      method: 'scripts',
      _username,
    }
    const response = await dispatch('softaculous_api', data, { root: true })
    if (!response.iscripts) {
      throw new Error('Unable to load available installations.')
    }
    const wpSoftId = Object.entries(response.iscripts).find(script => script[1]?.softname == 'wp')[0]
    commit('SET_SOFT_ID', wpSoftId)
  },
  async getSoftInfo ({ commit, dispatch, getters }, _username) {
    const data = {
      method: `software&soft=${getters.softId}&giveinfo=1`,
      _username,
    }
    const response = await dispatch('softaculous_api', data, { root: true })
    if (Array.isArray(response?.settings?.['Extended Settings']?.language?.orig_val)) {
      commit('SET_LANGUAGES', response.settings['Extended Settings'].language.orig_val)
    }
  },
  async getConfigureOptions ({ commit, getters, rootGetters }, _username) {
    const data = {
      serviceID: rootGetters['hosting'].id,
      application: getters.wizardApp,
      _username,
    }
    const response = await amapi.makecall('wizard_step2', data)
    const themes = Array.isArray(response.options.themes) ? response.options.themes : []
    commit('SET_AVAILABLE_PLUGINS', Array.isArray(response.options.plugins) ? response.options.plugins : [])
    commit('SET_AVAILABLE_THEMES', themes)
  },
  /**
   * @typedef { Error & { installationExists?: boolean } } InstallationError
   * @throws { InstallationError } - error.installationExists === true if installation already exists
   */
  async installWp ({ commit, dispatch, getters, rootState }, { overwrite = 0, _username }) {
    const params = {
      method: 'software&soft=' + getters.softId,
      _username,
      payload: {
        softsubmit: 1,
        softdomain: getters.softdomain,
        softproto: getters.softproto,
        softdirectory: getters.softdirectory,
        language: getters.language,
        softdb: getters.softdb,
        dbusername: getters.dbusername,
        dbuserpass: getters.dbuserpass,
        admin_username: getters.admin_username,
        admin_pass: getters.admin_pass,
        admin_email: getters.admin_email,
        site_name: getters.site_name,
        site_desc: getters.site_desc,
        overwrite_existing: overwrite,
      }
    }
    if (getters.wizardApp === 'extendify') {
      params.payload.extendify = 1
    }
    let response = await amapi.softaculous_api(params)
    if (response === null) {
      response = await dispatch('makeFakeResponseForRecentInstallation', { attempt: 1, username: _username, domain: getters.softdomain, dbpass: getters.dbuserpass, softdb: getters.softdb })
    }
    if (!response.done) {
      const msg = Array.isArray(response.error) ? response.error[0] : Object.values(response.error)[0]
      const err = new Error(msg ?? 'Unexpected error occurred')
      if (response.error.exists) {
        err.installationExists = true
      }
      commit('ADD_DOMAINS_INSTALLATION_RECENTLY_FAILED', params.payload.softdomain)
      throw err
    }
    commit('SET_INST_ID', response.insid)
    commit('REMOVE_DOMAINS_INSTALLATION_RECENTLY_FAILED', params.payload.softdomain)
  },
  async makeFakeResponseForRecentInstallation ({ commit, dispatch, getters, rootState }, { attempt, username, domain, dbpass, softdb }) {
    if (attempt > 5) {
      const e = 'Can not get data of your installation. Reload the page'
      return {
        done: false,
        error: [e]
      }
    }
    await dispatch('hosting_wp/getInstallationsList', username, { root: true })
    const newestInstallation = (rootState.hosting_wp.installations.toSorted((a, b) => b.itime - a.itime)).at(0)
    if (!newestInstallation) {
      return dispatch('makeFakeResponseForRecentInstallation', { attempt: attempt + 1, username, domain, dbpass, softdb })
    }
    if (
      newestInstallation.softdomain === domain &&
      newestInstallation.display_softdbpass === dbpass &&
      newestInstallation.softdb.split('_')[1] === softdb
    ) {
      return {
        done: true,
        insid: newestInstallation.insid
      }
    }
    return dispatch('makeFakeResponseForRecentInstallation', { attempt: attempt + 1, username, domain, dbpass, softdb })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
